module.exports = __webpack_public_path__ + "img/biohazard-solid.2a3c6780.svg";